import React, {Component} from 'react';
import {withRouter} from 'react-router';
import {Link, NavLink} from 'react-router-dom';
import {
  Dropdown,
  Menu,
  Icon,
  Responsive,
  Modal,
  Header,
} from 'semantic-ui-react';
import {connect} from 'react-redux';
import styled from 'react-emotion';
import {cx} from 'emotion';
import {withActions} from 'actionware';

import logo from '../assets/logo-text.png';
import {logout} from '../../store/identity';
import * as styles from './Layout';
import RequiresRole, {ROLES} from '../security/RequiresRole';
import {colors} from '../../styles';

const MenuWrapper = styled.div`
  ${styles.fixed};
  z-index: 1;
  background: #fff;
  padding: 20px 45px;
  border-bottom: solid 1px #e6e6e3;

  .ui.menu .item > img:not(.ui) {
    width: 7em;
  }

  .ui.menu {
    font-size: 0.9rem;

    .item {
      text-transform: uppercase;

      & > i.icon {
      }
    }
  }

  .ui.secondary.pointing.menu {
    border-bottom: 2px solid #fff;
    display: flex;
    align-items: center;

    .item {
      align-self: center;

      &.active.dropdown {
        border-color: #dfae38;
      }
    }
  }

  .menu-divider {
    display: flex;
    width: 1px;
    margin: 10px 1px 10px 0;
    border-right: solid 1px rgba(0, 0, 0, 0.2);
  }
`;

class AppHeader extends Component {
  _renderUserMenu = () => {
    const {user} = this.props;
    return (
      <Menu.Menu position="right">
        <Menu.Item>{`Hi, ${user.firstName} ${user.lastName} `}</Menu.Item>
        <Dropdown
          item
          trigger={<Icon name="user" style={{color: colors.greenPrimary}} />}
        >
          <Dropdown.Menu>
            <Dropdown.Item as={Link} to="/account/change-password">
              Change Password
            </Dropdown.Item>
            <Dropdown.Item onClick={this.props.logout}>Logout</Dropdown.Item>
            <Dropdown.Divider />
            <Modal
              trigger={<Dropdown.Item>Support</Dropdown.Item>}
              centered={false}
              size="tiny"
            >
              <Modal.Content>
                <Header
                  size="large"
                  textAlign="center"
                  style={{
                    fontWeight: 'normal',
                    borderBottom: 'solid 2px #DFAE38',
                    display: 'inline-block',
                  }}
                >
                  Support for the M&M Int’l Product Documentation Portal
                </Header>
                <p>
                  If you encounter a problem when using our Product
                  Documentation Portal, have any questions about your
                  documentation, or would like to request access to search by
                  your company’s P.O. or part numbers, please contact us at{' '}
                  <a href="mailto:portalsupport@mmvalve.com">
                    portalsupport@mmvalve.com
                  </a>
                  .
                </p>
              </Modal.Content>
            </Modal>
          </Dropdown.Menu>
        </Dropdown>
      </Menu.Menu>
    );
  };

  render() {
    const isManage = this.props.location.pathname.indexOf('/manage') === 0;
    return (
      <MenuWrapper>
        <Menu pointing secondary>
          <Menu.Item as={Link} to="/product-documentation" className="logo">
            <img src={logo} alt="M&M International" />
          </Menu.Item>
          <Responsive as={React.Fragment} minWidth={850}>
            <RequiresRole roles={[ROLES.CUSTOMER_ADMIN]}>
              <Menu.Item as={NavLink} to="/order-history">
                Order History
              </Menu.Item>
              <Menu.Item as={NavLink} to="/manage/users">
                Manage Users
              </Menu.Item>
            </RequiresRole>
            <RequiresRole roles={[ROLES.SYSTEM_ADMIN, ROLES.MM_ADMIN]}>
              <Dropdown
                item
                pointing
                trigger={<div>Manage</div>}
                className={cx({active: isManage})}
              >
                <Dropdown.Menu>
                  <Menu.Item as={Link} to="/manage/blacklists">
                    Blacklists
                  </Menu.Item>
                  <Menu.Item as={Link} to="/manage/whitelists">
                    Whitelists
                  </Menu.Item>
                  <Menu.Item as={Link} to="/manage/customers">
                    Customers
                  </Menu.Item>
                  <Dropdown.Item as={Link} to="/manage/users">
                    Users
                  </Dropdown.Item>
                  <Menu.Item as={Link} to="/manage/searches">
                    Searches
                  </Menu.Item>
                  <RequiresRole roles={[ROLES.SYSTEM_ADMIN]}>
                    <Dropdown.Item as={Link} to="/manage/settings">
                      Settings
                    </Dropdown.Item>
                  </RequiresRole>
                </Dropdown.Menu>
              </Dropdown>
            </RequiresRole>
            <Menu.Item as={NavLink} to="/product-documentation">
              Product Documentation
            </Menu.Item>
            <Menu.Item as={NavLink} to="/resources">
              Resources
            </Menu.Item>
          </Responsive>
          {this._renderUserMenu()}
        </Menu>
      </MenuWrapper>
    );
  }
}

const mapStateToProps = ({identity}) => ({
  user: identity.user,
});

const WithActions = withActions({logout})(AppHeader);
const Connected = connect(mapStateToProps)(WithActions);
export default withRouter(Connected);